/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var progressbar_base_1 = require("../common/progressbar-base");
var core_1 = require("@angular/core");
var util_1 = require("../common/util");
var kendo_angular_l10n_1 = require("@progress/kendo-angular-l10n");
/**
 * Represents the [Kendo UI ChunkProgressBar component for Angular]({% slug overview_chunkprogressbar %}).
 *
 * @example
 * ```ts-preview
 * _@Component({
 *    selector: 'my-app',
 *    template: `
 *        <kendo-chunkprogressbar [value]="value">
 *        </kendo-chunkprogressbar>
 *    `
 * })
 * class AppComponent {
 *     public value = 40;
 * }
 * ```
 */
var ChunkProgressBarComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ChunkProgressBarComponent, _super);
    /**
     * @hidden
     */
    function ChunkProgressBarComponent(localization) {
        var _this = _super.call(this, localization) || this;
        _this.localization = localization;
        /**
         * Sets the number of chunks into which the ChunkProgressBar will be split.
         * Defaults to `5`.
         */
        _this.chunkCount = 5;
        _this._orientationStyles = {
            width: _this.chunkSizePercentage + "%"
        };
        return _this;
    }
    Object.defineProperty(ChunkProgressBarComponent.prototype, "chunks", {
        /**
         * @hidden
         */
        get: function () {
            var count = this.chunkCount;
            var chunks = Array(count).fill(false);
            var completedChunks = Math.floor(this._progressRatio * count);
            for (var i = 0; i < completedChunks; i++) {
                chunks[i] = true;
            }
            if (util_1.reverseChunks(this.orientation, this.reverse)) {
                chunks.reverse();
            }
            return chunks;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChunkProgressBarComponent.prototype, "chunkSizePercentage", {
        /**
         * @hidden
         */
        get: function () {
            return 100 / this.chunkCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChunkProgressBarComponent.prototype, "orientationStyles", {
        /**
         * @hidden
         */
        get: function () {
            if (this.orientation === 'horizontal') {
                this._orientationStyles.width = this.chunkSizePercentage + "%";
                this._orientationStyles.height = undefined;
            }
            else {
                this._orientationStyles.height = this.chunkSizePercentage + "%";
                this._orientationStyles.width = undefined;
            }
            return this._orientationStyles;
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", Number)
    ], ChunkProgressBarComponent.prototype, "chunkCount", void 0);
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", Object)
    ], ChunkProgressBarComponent.prototype, "progressCssStyle", void 0);
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", Object)
    ], ChunkProgressBarComponent.prototype, "progressCssClass", void 0);
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", Object)
    ], ChunkProgressBarComponent.prototype, "emptyCssStyle", void 0);
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", Object)
    ], ChunkProgressBarComponent.prototype, "emptyCssClass", void 0);
    ChunkProgressBarComponent = tslib_1.__decorate([
        core_1.Component({
            exportAs: 'kendoChunkProgressBar',
            selector: 'kendo-chunkprogressbar',
            template: "\n        <ul class=\"k-reset\">\n            <li class=\"k-item\" *ngFor=\"let chunk of chunks; let i = index;\"\n                [class.k-first]=\"i === 0\"\n                [class.k-last]=\"i === chunkCount - 1\"\n                [class.k-state-selected]=\"chunk\"\n                [ngClass]=\"chunk ? progressCssClass : emptyCssClass\"\n                [ngStyle]=\"chunk ? progressCssStyle : emptyCssStyle\"\n                [style.width]=\"orientationStyles.width\"\n                [style.height]=\"orientationStyles.height\"\n                >\n            </li>\n        </ul>\n    ",
            providers: [
                kendo_angular_l10n_1.LocalizationService,
                {
                    provide: kendo_angular_l10n_1.L10N_PREFIX,
                    useValue: 'kendo.chunkprogressbar'
                }
            ]
        }),
        tslib_1.__metadata("design:paramtypes", [kendo_angular_l10n_1.LocalizationService])
    ], ChunkProgressBarComponent);
    return ChunkProgressBarComponent;
}(progressbar_base_1.ProgressBarBase));
exports.ChunkProgressBarComponent = ChunkProgressBarComponent;
